import { render, staticRenderFns } from "./rankingItem.vue?vue&type=template&id=20c6f031&scoped=true&"
import script from "./rankingItem.vue?vue&type=script&lang=js&"
export * from "./rankingItem.vue?vue&type=script&lang=js&"
import style0 from "./rankingItem.vue?vue&type=style&index=0&id=20c6f031&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c6f031",
  null
  
)

export default component.exports